import { render } from "./UpcomingEventsCard.vue?vue&type=template&id=eb137d2c"
import script from "./UpcomingEventsCard.vue?vue&type=script&lang=js"
export * from "./UpcomingEventsCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__